import { render, staticRenderFns } from "./rebookingsAftercare.vue?vue&type=template&id=51047060&scoped=true"
import script from "./rebookingsAftercare.vue?vue&type=script&lang=js"
export * from "./rebookingsAftercare.vue?vue&type=script&lang=js"
import style0 from "./rebookingsAftercare.vue?vue&type=style&index=0&id=51047060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51047060",
  null
  
)

export default component.exports